// @ts-nocheck
/* eslint-disable */
export const appCapacityManager24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M3 3L3 21L21 21" stroke="currentColor" stroke-width="2"/><path d="M6 15L10.375 10.625L13.875 14.125L20 8" stroke="currentColor" stroke-width="2"/></svg>`,
    name: 'capacity-manager-24' as const
};